import React, { useMemo } from 'react'
import { ITransportationOrderDetail } from '../../../../../../../modules/API/Seller/models/transportation'
import styled from 'styled-components';
import ProductImage from '../../../../queries/TeudotDetails/Components/ProductImage';
import TitleLayout from '../../../../kosherTeudot/generic/TitleLayout';
import TitleRow from '../../../../kosherTeudot/generic/TitleRow';
import TitleRowItem from '../../../../kosherTeudot/generic/TitleRowItem';
import AppleIcon from '../../../../../../../generic/icons/IconLib/AppleIcon';
import PalletIcon from '../../../../../../../generic/icons/IconLib/PalletIcon';
import ScalesIcon from '../../../../../../../generic/icons/IconLib/ScaleIcon';

interface ISectionProductWrapperProps {
  product: ITransportationOrderDetail
  list: ITransportationOrderDetail[]
  children: React.ReactNode | React.ReactNode[]
}

const SectionProductWrapper = (props: ISectionProductWrapperProps) => {
  const { product, list, children } = props;
  const palletQty = useMemo(() => {
    return list.reduce((acc, item) => acc + item.Order_Pallets, 0)
  }, [list])
  return (
    <MainWrapper>
      <TitleLayout disableShadow>
        <SideWrapper>
          <ProductImage id={product.GeneralProductID} />
        </SideWrapper>
        <TitleRow>
          <TitleRowItem name={`${product.ProductDesc.trim()} ${product.VarietyDesc.trim()} ${product.SizeID.trim()}`} icon={<AppleIcon />} />
        </TitleRow>
        <TitleRow>
          {/* <TitleRowItem name={product.SupplyWeight.toFixed(1)} icon={<ScalesIcon />} /> */}
          <TitleRowItem name={palletQty} icon={<PalletIcon />} />
        </TitleRow>
      </TitleLayout>
      <ListWrapper>
        {children}
      </ListWrapper>
    </MainWrapper>
  )
}

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;

`

const SideWrapper = styled.div`
  position: absolute;
  width: 3em;
  height: 3em;
  top: calc(50% - 3em/2);
  left: 0.5em;
`

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2em;
  padding: 0.2em;
`

export default SectionProductWrapper